enum GlobalSearchSortType {
    Relevance = "relevance",
    Created = "created",
    LastUpdated = "updated"
}

const GlobalSearchSortTypeLabels: Record<GlobalSearchSortType, string> = {
    [GlobalSearchSortType.Relevance]: "Relevance",
    [GlobalSearchSortType.Created]: "Created",
    [GlobalSearchSortType.LastUpdated]: "Last Updated"
};

const GlobalSearchSortTypeEventLabels: Record<GlobalSearchSortType, string> = {
    [GlobalSearchSortType.Relevance]: "relevance",
    [GlobalSearchSortType.Created]: "created",
    [GlobalSearchSortType.LastUpdated]: "last updated"
};

export default GlobalSearchSortType;
export { GlobalSearchSortTypeLabels, GlobalSearchSortTypeEventLabels };
